import { BaseDriver } from '@wix/wix-ui-test-utils/driver-factory';
import type { BadgeSkin, BadgeSize, BadgeType } from './index';

export interface BadgeDriver extends BaseDriver {
  exists(): boolean;
  text(): string;
  getType(): BadgeType;
  getSkin(): BadgeSkin;
  getSize(): BadgeSize;
  isUppercase(): boolean;
  hasClickCursor(): boolean;
  click(): void;
}
